import { nameValuePropType } from '@deltek/specification-client/core/Models/nameValuePropType'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import React from 'react'
import ProjectInput, { ProjectInputProps } from './ProjectInput'

const useStyles = makeStyles((theme: Theme) => ({
    chipText: {
        fontSize: pxToRem(14),
        maxWidth: '65%',
    },
    selectLabel: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
}))
export interface ProjectInputMultiProps extends ProjectInputProps {
    value: string | null | undefined
    handleChange: (name: string, value: string | null | undefined) => void
    inputType?: string
}

const ProjectInputMulti: React.FC<ProjectInputMultiProps> = ({
    options,
    value,
    name,
    label,
    placeholder,
    maxLength,
    required,
    error,
    handleChange,
    inputType,
}) => {
    const classes = useStyles()

    const projectInputProps = {
        options,
        name,
        label,
        maxLength,
        required,
        error,
        multiple: true,
        disableCloseOnSelect: true,
        limitTags: 1,
        placeholder,
        ChipProps: {
            variant: 'outlined',
            size: 'small',
            className: clsx(classes.chipText, classes.selectLabel),
        },
        value:
            options.filter((group: Record<nameValuePropType, string>) =>
                value?.split(',').includes(group.value)
            ) || [],
        onChange: (
            _: React.ChangeEvent<{}>,
            items: Record<nameValuePropType, string>[]
        ) => {
            if (inputType === 'Contract Type') {
                const itemIndex = items.map((item) => item.name).indexOf('None')
                if (items.length > 1 && items[0].name === 'None') {
                    ~itemIndex && items.splice(itemIndex, 1)
                }
                if (items.some((item) => item.name === 'None')) {
                    const noneItem = items[itemIndex]
                    items = []
                    items.push(noneItem)
                }
            }
            options.length !== 0 &&
                handleChange(name, items.map((item) => item.value).join(','))
        },

        onInputChange: (_: React.ChangeEvent<{}>, item: string) => {
            options.length === 0 && handleChange(name, item)
        },
    }
    return <ProjectInput {...projectInputProps} />
}

export default ProjectInputMulti
